// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../DOM__Element.bs.js");
var Label__Shared$SmartcutsMacros = require("./Label__Shared.bs.js");

function t_encode(encoder_emailText, v) {
  return Js_dict.fromArray([
              [
                "emailText",
                Curry._1(encoder_emailText, v.emailText)
              ],
              [
                "elementWithEmailText",
                Selector$SmartcutsMacros.selector_encode(v.elementWithEmailText)
              ],
              [
                "sharedRootDepth",
                Decco.intToJson(v.sharedRootDepth)
              ]
            ]);
}

function t_decode(decoder_emailText, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var emailText = Curry._1(decoder_emailText, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailText"), null));
  if (emailText.TAG === /* Ok */0) {
    var elementWithEmailText = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementWithEmailText"), null));
    if (elementWithEmailText.TAG === /* Ok */0) {
      var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
      if (sharedRootDepth.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  emailText: emailText._0,
                  elementWithEmailText: elementWithEmailText._0,
                  sharedRootDepth: sharedRootDepth._0
                }
              };
      }
      var e = sharedRootDepth._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".sharedRootDepth" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = elementWithEmailText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".elementWithEmailText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = emailText._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".emailText" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify(stringifyEmailText, param) {
  return "{ emailText: " + (Curry._1(stringifyEmailText, param.emailText) + (", elementWithEmailText: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.elementWithEmailText) + (", sharedRootDepth: " + (String(param.sharedRootDepth) + " }")))));
}

function applyInnerTextSemantics(resolveEmailText, emailLabel) {
  var emailText = emailLabel.emailText;
  return {
          emailText: emailLabel.emailText,
          elementWithEmailText: Selector$SmartcutsMacros.updateLeafNode((function (node) {
                  return {
                          id: node.id,
                          tagName: node.tagName,
                          classNames: node.classNames,
                          attributes: node.attributes,
                          index: node.index,
                          innerText: {
                            TAG: /* FullInnerText */0,
                            _0: Curry._1(resolveEmailText, emailText)
                          },
                          isScrollable: node.isScrollable,
                          attributeBlacklist: node.attributeBlacklist
                        };
                }), emailLabel.elementWithEmailText),
          sharedRootDepth: emailLabel.sharedRootDepth
        };
}

function waitForElementInForegroundWithMatchingLabel(resolveEmailText, emailLabel, selector) {
  var match = applyInnerTextSemantics(resolveEmailText, emailLabel);
  return Label__Shared$SmartcutsMacros.waitForElementInForegroundWithMatchingLabel(match.elementWithEmailText, match.sharedRootDepth, undefined, selector);
}

function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, resolveEmailText, emailLabel, selector) {
  var match = applyInnerTextSemantics(resolveEmailText, emailLabel);
  return Label__Shared$SmartcutsMacros.waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, match.elementWithEmailText, match.sharedRootDepth, undefined, selector);
}

var regexp = new RegExp("([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)", "g");

function maybeFromElement(element) {
  return Belt_Option.flatMap(DOM__Element$SmartcutsMacros.maybeInnerText(element), (function (innerText) {
                return Belt_Option.map(StringUtils$SmartcutsMacros.myMatch(innerText, regexp), (function (matches) {
                              if (matches.length === 1) {
                                var emailText = matches[0];
                                if (Caml_obj.caml_equal(innerText, emailText)) {
                                  return {
                                          TAG: /* ExactMatch */0,
                                          _0: innerText
                                        };
                                }
                                
                              }
                              return {
                                      TAG: /* ContainsEmailText */1,
                                      _0: Belt_Array.keepMap(matches, (function (x) {
                                              return x;
                                            })),
                                      _1: innerText
                                    };
                            }));
              }));
}

var EmailTextMatchResult = {
  maybeFromElement: maybeFromElement
};

function childElementsExactMatchEmailText(element) {
  return Belt_Array.reduce(Array.prototype.slice.call(element.childNodes), [], (function (elementsExactMatchEmailText, childNode) {
                var arg = Belt_Option.flatMap(Webapi__Dom__Element.ofNode(childNode), (function (childElement) {
                        return Belt_Option.map(maybeFromElement(childElement), (function (matchResult) {
                                      if (matchResult.TAG === /* ExactMatch */0) {
                                        return Belt_Array.concat(elementsExactMatchEmailText, [childElement]);
                                      } else {
                                        return Belt_Array.concat(elementsExactMatchEmailText, childElementsExactMatchEmailText(childElement));
                                      }
                                    }));
                      }));
                return OptionUtils$SmartcutsMacros.withDefault(elementsExactMatchEmailText, arg);
              }));
}

function forDomElement(domElement) {
  var match = maybeFromElement(domElement);
  if (match !== undefined) {
    if (match.TAG === /* ExactMatch */0) {
      return /* ThisElement */0;
    } else {
      return {
              TAG: /* Children */0,
              _0: childElementsExactMatchEmailText(domElement)
            };
    }
  } else {
    return Belt_Option.map(DOM__Element$SmartcutsMacros.closestSome((function (element) {
                      return Belt_Option.flatMap(maybeFromElement(element), (function (result) {
                                    if (result.TAG === /* ExactMatch */0) {
                                      return [result._0];
                                    } else {
                                      return result._0;
                                    }
                                  }));
                    }), domElement), (function (param) {
                  var sharedRoot = param[0];
                  return {
                          TAG: /* Cusins */1,
                          _0: sharedRoot,
                          _1: childElementsExactMatchEmailText(sharedRoot)
                        };
                }));
  }
}

var LocateEmailElements = {
  EmailTextMatchResult: EmailTextMatchResult,
  childElementsExactMatchEmailText: childElementsExactMatchEmailText,
  forDomElement: forDomElement
};

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.applyInnerTextSemantics = applyInnerTextSemantics;
exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel;
exports.regexp = regexp;
exports.LocateEmailElements = LocateEmailElements;
/* regexp Not a pure module */
